import { SetStateAction } from "react";
import { emptys } from "../../../data/main";
import { stdObject } from "../../../data/types/stdObject";
import { colors } from "../../../data/colors";
import { quickNumberInput } from "../../../utils/quickNumberInput";

export const mainDataModal = ({
  t,
  handleMainData,
  deleteMainData,
  modalData,
  windowValues,
  setWindowValues,
  windowValues2,
  setWindowValues2,
  updateWindowValue,
  closeMsg,
}: stdObject) => {
  return {
    title: modalData.title,
    blocked: true,
    inputs:
      "inputs" in modalData &&
      modalData.inputs.map((e: stdObject) => {
        return {
          ...e,
          label: t(e.label),
          value: windowValues[e.code] ?? "",
          type: e.type,
          options: e.options,
          active:
            !["RESCAJ", "APLDIN", "FEC2DIN"].includes(e.code) ||
            (e.code === "RESCAJ" &&
              emptys.includes(windowValues.TRACAJ) &&
              windowValues.FLOWCAJ?.toString() === "1"),
          innerStyle: e.innerStyle,
          onChange: (o: { target: { value: SetStateAction<string> } }) => {
            let value = o.target.value;
            if (e.calcInput) {
              value = quickNumberInput(value, windowValues[e.code] ?? "");
            }
            updateWindowValue({
              code: e.code,
              value: e.type === "checkbox" ? (Number(value) ? 0 : 1) : value,
              windowValues,
              setWindowValues,
              windowValues2,
              setWindowValues2,
            });
          },
          onKeyDown: (o: stdObject) => {
            if (e.calcInput && ["Escape", "Delete"].includes(o.key)) {
              updateWindowValue({
                code: e.code,
                value: "",
                windowValues,
                setWindowValues,
                windowValues2,
                setWindowValues2,
              });
            }
          },
        };
      }),
    buttons: [
      {
        label: modalData.index === -1 ? t("p.create") : t("p.update"),
        onClick: () => handleMainData(),
        color: colors.green,
      },
      modalData.code > 0 && {
        label: t("p.delete"),
        onClick: () => deleteMainData(),
        color: colors.red,
      },
      {
        label: t("p.cancel"),
        onClick: () => closeMsg(),
        color: colors.darkGrey,
      },
    ],
  };
};
